export const exchange = {
  name: 'exchangeMain',
  path: '/exchangeMain',
  component: () => import('@/views_mobile/member/exchange'),
  redirect: {
    name: 'exchange'
  },
  meta: {
    layout: 'mobile-default',
    text: '베팅리스트',
    gnb: false,
    gnbMenu: 'exchange'
  },
  children: [
    {
      name: 'exchange',
      path: '/exchange',
      component: () => import('@/views_mobile/member/exchange/exchange'),
      meta: {
        layout: 'mobile-default',
        text: '베팅리스트',
        gnb: false,
        gnbMenu: 'exchange'
      }
    },
    {
      name: 'coinExchange',
      path: '/coinExchange',
      component: () => import('@/views_mobile/member/exchange/coinExchange'),
      meta: {
        layout: 'mobile-default',
        text: '베팅리스트',
        gnb: false,
        gnbMenu: 'coinExchange'
      }
    }
  ]
}
